module.exports = __webpack_public_path__ + "static/assets/92a02c55d21b8e5697a55ac2c073bc75.svg";